import { useTranslation } from "react-i18next"
import { PermissionsSummaryWrapper } from "./styles"
import { IoCheckmark, IoClose } from "react-icons/io5"
interface IProps {
	summaryOfPermissionsList: {
		lable: string
		isActie: boolean
	}[]
}
export default function PermissionsSummary({
	summaryOfPermissionsList,
}: IProps) {
	const { t } = useTranslation()

	return (
		<PermissionsSummaryWrapper>
			<div className='header'>
				<p>{t("UserManagement.permissions_summary")} :</p>
			</div>
			<div className='viewList'>
				<div className='containerHeader'>
					<div>{t("UserManagement.permission")}</div>
					<div>{t("UserManagement.status")}</div>
				</div>
				{summaryOfPermissionsList?.map((item, index) => {
					return (
						<div className='containerList' key={index}>
							<div>{item.lable}</div>
							{item.isActie ? (
								<div className='Checkmark'>
									<IoCheckmark />
								</div>
							) : (
								<div className='Close'>
									<IoClose />
								</div>
							)}
						</div>
					)
				})}
			</div>
		</PermissionsSummaryWrapper>
	)
}
